// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"56d5e37b","298":"36818154","445":"314673c1","479":"250eb1d0","594":"250eb1d0","661":"6d462272","810":"250eb1d0","822":"fa92b869"}[chunkId] + ".chunk.css";
};